const sgFormats = {
  number: {
    LOCALE_CURRENCY: {
      style: 'currency',
      currency: 'SGD',
    },
  },
  date: {
    LOCALE_DATE: {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    },
  },
};

export { sgFormats };
